import { BrainCircuit, ShieldAlert, FileCheck2 } from "lucide-react";

const RISK = {
  faible: { label: "Faible", cls: "faible" },
  moyen: { label: "Moyen", cls: "moderee" },
  eleve: { label: "Élevé", cls: "elevee" },
};

export default function EngineInsight({ moteur }) {
  if (!moteur || (!moteur.dangersDetectes?.length && !moteur.permisRecommandes?.length)) return null;
  const r = RISK[moteur.niveauRisque] || RISK.faible;

  return (
    <div className="engine-insight" data-testid="engine-insight">
      <div className="ei-head">
        <BrainCircuit size={17} />
        <span>Analyse du moteur métier</span>
        <span className={`badge b-${r.cls}`} style={{ marginLeft: "auto" }} data-testid="ei-risque">
          <ShieldAlert size={12} /> Risque {r.label}
        </span>
      </div>

      {moteur.narratif && <p className="ei-narr" data-testid="ei-narratif">{moteur.narratif}</p>}

      {moteur.dangersDetectes?.length > 0 && (
        <div className="ei-block">
          <div className="ei-sub">Le moteur a détecté</div>
          <div className="ei-chips">
            {moteur.dangersDetectes.map((d, i) => <span className="chip on" key={i}>{d}</span>)}
          </div>
        </div>
      )}

      {moteur.permisRecommandes?.length > 0 && (
        <div className="ei-block">
          <div className="ei-sub">Permis / autorisations recommandés</div>
          <ul className="ei-permis">
            {moteur.permisRecommandes.map((p) => (
              <li key={p.code} data-testid={`ei-permis-${p.code}`}>
                <FileCheck2 size={14} />
                <div><b>{p.label}</b><span className="ei-raison">{p.raison}</span></div>
              </li>
            ))}
          </ul>
          <div className="ei-note">Ces recommandations ne bloquent pas la validation — elles vous aident à préparer l'intervention.</div>
        </div>
      )}
    </div>
  );
}
